import { BreachPathDetailsController } from '../controller/BreachPathDetailsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class BreachPathDetailsWebComponent extends BaseWebComponentElement {
  public breachPathIssueId: string;
  public tabName: string;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: BreachPathDetailsController,
    });
  }
}
